import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { IImportSettingsMcbSftp } from './import-settings-mcb-sftp.model';

@Injectable({
  providedIn: 'root'
})
export class ImportSettingsMcbSftpService {

  constructor(
    private firestore: AngularFirestore,
  ) { }

  public get(bankAccountId: string): Observable<IImportSettingsMcbSftp> {
    const doc = `bank-accounts/${bankAccountId}/settings/import-mcb-sftp`;
    return this.firestore.doc<IImportSettingsMcbSftp>(doc).valueChanges().pipe(
      map((settings) => {
        const defaultSettings: IImportSettingsMcbSftp = {
          host: 'sftp1.mcb-bank.com',
          port: 22,
          username: '',
          password: '',
          folder: '',
        };
        return (settings) ? settings : defaultSettings;
      })
    );
  }

  public save(bankAccountId: string, settings: IImportSettingsMcbSftp): Promise<void> {
    const doc = `bank-accounts/${bankAccountId}/settings/import-mcb-sftp`;
    return this.firestore.doc<IImportSettingsMcbSftp>(doc).set(settings);
  }

}
